import createFetchActions from './createFetchActions';

const saveProjectActions = createFetchActions('SAVE_PROJECT', {
  failure_payload: (project, exception) => ({
    project,
    exception
  })
});
export { saveProjectActions };
